import React from "react";
// Superseded — the manual-domain-entry dialog below violated Shopify App Store
// requirement 2.3.1 ("must not request the manual entry of a myshopify.com URL...
// during the installation or configuration flow" — confirmed via a real rejection
// precedent covering exactly this "connect the app to another store" scenario, not
// just first install). Commented out, not deleted. The backend endpoint it called
// (GET /api/integrations/shopify/login) is also commented out —
// see shopifyOAuthController.js / shopifyIntegrationRoutes.js.
// import { useState } from "react";
// import {
//   Button,
//   Box,
//   CircularProgress,
//   Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
// } from "@mui/material";
// import { useSelector } from "react-redux";
// import { getAccessToken } from "../../../utils/tokenManager";
// import { getAuthToken } from "../../../utils/getAuthToken";
// import { fetchShopifyAuthorizationUrl } from "../../../services/shopifyApi";
import { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";

// const SHOP_DOMAIN_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com$/;

/**
 * Outer button shows the plain label ("Connect"/"Reconnect", per Integrations.jsx's
 * connected-state logic) and opens an explanatory dialog rather than navigating
 * straight to the Shopify App Store — matches the confirm-before-leaving-the-app
 * pattern of other "Install on Shopify"-style integrations (e.g. BotSpace) instead
 * of an unexplained same-tab redirect on the very first click.
 *
 * The dialog's own "Install on Shopify" action sends the merchant to the App Store
 * listing, where Shopify's own UI handles "which store" (no domain typing on our
 * side at all). Which ClusterDen account/workspace this connection lands on is
 * decided server-side once Shopify redirects back to our application_url — see
 * shopifyOAuthService.js's initiateFromAppUrl (detects an already-logged-in
 * session via the refreshToken cookie) and, for a session it can't detect, the
 * explicit "Log in instead" link on Welcome.jsx / the claim-pending endpoint.
 */
const ConnectShopifyButton = ({ sx, label = "Connect" }) => {
  const appHandle = process.env.REACT_APP_SHOPIFY_APP_HANDLE;
  const [dialogOpen, setDialogOpen] = useState(false);
  const isReconnect = label === "Reconnect";

  const handleInstallClick = () => {
    window.location.href = `https://apps.shopify.com/${appHandle}`;
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setDialogOpen(true)}
        sx={{ textTransform: "none", width: "fit-content", ...sx }}
      >
        {label}
      </Button>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontSize: "1.4rem", fontWeight: 700, pt: 3, px: 3 }}>
          {isReconnect ? "Reconnect Shopify Store" : "Add Shopify Integration"}
        </DialogTitle>
        <DialogContent sx={{ px: 3 }}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
            {isReconnect
              ? "To reconnect your Shopify store with ClusterDen, you'll be taken to the Shopify App Store to re-approve access."
              : "To connect your Shopify store with ClusterDen, please install the ClusterDen app from the Shopify App Store."}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => setDialogOpen(false)}
            size="large"
            sx={{ textTransform: "none", fontSize: "1rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleInstallClick}
            size="large"
            sx={{ textTransform: "none", fontSize: "1rem", px: 3 }}
          >
            Install on Shopify
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  // ── Previous implementation (manual domain entry) — kept for reference ──
  // const workspaceId = useSelector(
  //   (s) => s.workspace?.currentWorkspace?._id || s.auth?.user?.workspaceId
  // );
  //
  // const [dialogOpen, setDialogOpen] = useState(false);
  // const [shopDomain, setShopDomain] = useState("");
  // const [loading, setLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  //
  // const handleConnect = async () => {
  //   setErrorMessage("");
  //
  //   if (!workspaceId) {
  //     setErrorMessage("No workspace selected.");
  //     return;
  //   }
  //   const trimmedDomain = shopDomain.trim().toLowerCase();
  //   if (!SHOP_DOMAIN_PATTERN.test(trimmedDomain)) {
  //     setErrorMessage("Enter your store's *.myshopify.com domain (e.g. my-store.myshopify.com).");
  //     return;
  //   }
  //
  //   setLoading(true);
  //   try {
  //     let token = getAccessToken();
  //     if (!token) token = await getAuthToken();
  //     if (!token) {
  //       setErrorMessage("Not authenticated.");
  //       setLoading(false);
  //       return;
  //     }
  //
  //     const authorizationUrl = await fetchShopifyAuthorizationUrl(workspaceId, trimmedDomain, token);
  //     if (!authorizationUrl) {
  //       setErrorMessage("Could not start Shopify connection.");
  //       setLoading(false);
  //       return;
  //     }
  //
  //     window.location.href = authorizationUrl;
  //   } catch (err) {
  //     setErrorMessage(err.response?.data?.message || err.message || "Failed to start Shopify connection.");
  //     setLoading(false);
  //   }
  // };
  //
  // return (
  //   <>
  //     <Button
  //       variant="outlined"
  //       size="small"
  //       onClick={() => setDialogOpen(true)}
  //       sx={{ textTransform: "none", width: "fit-content", ...sx }}
  //     >
  //       {label}
  //     </Button>
  //
  //     <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
  //       <DialogTitle sx={{ fontSize: "1.4rem", fontWeight: 700, pt: 3, px: 3 }}>
  //         Connect Shopify Store
  //       </DialogTitle>
  //       <DialogContent sx={{ px: 3 }}>
  //         <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
  //           Enter your Shopify store's domain. You'll be redirected to Shopify to approve access.
  //         </Typography>
  //         <TextField
  //           fullWidth
  //           label="Store domain"
  //           placeholder="my-store.myshopify.com"
  //           value={shopDomain}
  //           onChange={(e) => setShopDomain(e.target.value)}
  //           disabled={loading}
  //           sx={{
  //             "& .MuiInputBase-input": { fontSize: "1.1rem", py: 1.75 },
  //             "& .MuiInputLabel-root": { fontSize: "1.05rem" },
  //           }}
  //         />
  //         {errorMessage && (
  //           <Typography color="error" variant="body2" sx={{ display: "block", mt: 1.5 }}>
  //             {errorMessage}
  //           </Typography>
  //         )}
  //       </DialogContent>
  //       <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
  //         <Button
  //           onClick={() => setDialogOpen(false)}
  //           disabled={loading}
  //           size="large"
  //           sx={{ textTransform: "none", fontSize: "1rem" }}
  //         >
  //           Cancel
  //         </Button>
  //         <Button
  //           variant="contained"
  //           onClick={handleConnect}
  //           disabled={loading}
  //           size="large"
  //           sx={{ textTransform: "none", fontSize: "1rem", px: 3 }}
  //         >
  //           {loading ? (
  //             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  //               Connecting <CircularProgress size={16} sx={{ color: "inherit" }} />
  //             </Box>
  //           ) : (
  //             "Continue to Shopify"
  //           )}
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   </>
  // );
};

export default ConnectShopifyButton;
